import Node from "./node";

class LRU {
  constructor({ size }) {
    this.size = 0;
    this.limit = size;
    this.head = null;
    this.tail = null;
    this.cache = {};
  }

  write(key, value) {
    this.ensureLimit();

    if (!this.head) {
      this.head = new Node(key, value);
      this.tail = this.head;
    } else {
      const node = new Node(key, value, this.head);
      this.head.prev = node;
      this.head = node;
    }

    this.cache[key] = this.head;
    this.size += 1;
  }

  read(key) {
    if (this.cache[key]) {
      const { value } = this.cache[key];

      this.remove(key);
      this.write(key, value);

      return value;
    }

    return undefined;
  }

  remove(key) {
    const node = this.cache[key];

    if (node.prev !== null) {
      node.prev.next = node.next;
    } else {
      this.head = node.next;
    }

    if (node.next !== null) {
      node.next.prev = node.prev;
    } else {
      this.tail = node.prev;
    }

    delete this.cache[key];
    this.size -= 1;
  }

  invalidate() {
    this.head = null;
    this.tail = null;
    this.size = 0;
    this.cache = {};
  }

  ensureLimit() {
    if (this.size === this.limit) {
      this.remove(this.tail.key);
    }
  }
}

export default LRU;
